import { useMemo } from 'react'
import { type ApInvoiceAuditEvent } from '@/features/invoices/view-models'
import { useInvoice } from '@/features/invoices/queries'
import { TimelineList } from '@/components/timeline'
import { formatStatus } from '@/lib/utils'
import { firstPoLink } from './formatting'

export function ActivityTimeline({
  events,
  invoice,
}: {
  events: ApInvoiceAuditEvent[] | undefined
  invoice: NonNullable<ReturnType<typeof useInvoice>['data']>
}) {
  const firstPo = firstPoLink(invoice)
  const mapped = useMemo(
    () =>
      (events ?? []).map((event) => ({
        uuid: `ap-invoice-event-${event.id}`,
        occurred_at: event.created_at,
        event_category: 'financial',
        event_type: event.event_type,
        title: event.title || event.summary || formatStatus(event.event_type),
        description: event.description,
        actor_name: event.actor_name,
        actor_type: event.actor_name ? 'user' : 'system',
        metadata_json: null,
        project: invoice.internal_project
          ? {
              uuid: invoice.internal_project.uuid,
              name: invoice.internal_project.name,
            }
          : undefined,
        purchase_order: firstPo?.purchase_order?.uuid
          ? {
              uuid: firstPo.purchase_order.uuid,
              po_number: firstPo.purchase_order.po_number || firstPo.po_number_raw || 'PO',
            }
          : undefined,
      })),
    [events, firstPo, invoice.internal_project],
  )

  return mapped.length ? (
    <TimelineList events={mapped} />
  ) : (
    <p className="text-sm text-muted-foreground">No timeline entries yet.</p>
  )
}
